package gr.tech.GRAttestation.styles.grstyles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

val DefaultTableStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
    }
}

val DefaultTableHeaderStyle = CssStyle {
    base {
        Modifier
            .minWidth(100.px)
            .position(Position.Sticky)
            .top(0.px)
    }
}